import { defineComponent as _defineComponent } from 'vue'
import { dir } from '@@/bits/current_dir'
import type { PostColor } from '@@/types'
import { computed } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'BeethovenAttachmentMetadataSlope',
  props: {
    usageContext: null,
    darkThemeType: { default: 'browser' },
    isDark: { type: Boolean, default: false },
    isWhiteboard: { type: Boolean, default: false },
    color: { default: 'default' }
  },
  setup(__props: any) {

const props = __props as { usageContext: 'postModal' | 'postView' | 'postPreview', darkThemeType: 'browser' | 'custom', isDark: boolean, isWhiteboard: boolean, color: 'default' | NonNullable<PostColor> };


const isBrowserDecidingDarkMode = computed(() => props.darkThemeType === 'browser')
const isForcedLight = computed(() => props.darkThemeType === 'custom' && !props.isDark)
const isForcedDark = computed(() => props.darkThemeType === 'custom' && props.isDark)
const wavySvgSize = computed(() => (props.isWhiteboard ? 32 : 25))
const lightMainBgColorClass = computed(() => {
  switch (props.color) {
    case 'red':
      return 'bg-scarlet-200'
    case 'orange':
      return 'bg-canary-200'
    case 'green':
      return 'bg-park-200'
    case 'blue':
      return 'bg-oceanic-200'
    case 'purple':
      return 'bg-grape-200'
    case 'default':
    default:
      return 'bg-light-ui-200'
  }
})

const darkMainBgColorClass = computed(() => {
  switch (props.color) {
    case 'red':
      return 'bg-scarlet-800'
    case 'orange':
      return 'bg-tangerine-800'
    case 'green':
      return 'bg-park-800'
    case 'blue':
      return 'bg-oceanic-800'
    case 'purple':
      return 'bg-grape-800'
    case 'default':
    default:
      return 'bg-dark-ui-200'
  }
})

const darkBrowserMainBgColorClass = computed(() => {
  switch (props.color) {
    case 'red':
      return 'dark:bg-scarlet-800'
    case 'orange':
      return 'dark:bg-tangerine-800'
    case 'green':
      return 'dark:bg-park-800'
    case 'blue':
      return 'dark:bg-oceanic-800'
    case 'purple':
      return 'dark:bg-grape-800'
    case 'default':
    default:
      return 'dark:bg-dark-ui-200'
  }
})

const lightSlopeColorClass = computed(() => {
  switch (props.color) {
    case 'red':
      return 'text-scarlet-200'
    case 'orange':
      return 'text-canary-200'
    case 'green':
      return 'text-park-200'
    case 'blue':
      return 'text-oceanic-200'
    case 'purple':
      return 'text-grape-200'
    case 'default':
    default:
      return 'text-light-ui-200'
  }
})

const darkSlopeColorClass = computed(() => {
  switch (props.color) {
    case 'red':
      return 'text-scarlet-800'
    case 'orange':
      return 'text-tangerine-800'
    case 'green':
      return 'text-park-800'
    case 'blue':
      return 'text-oceanic-800'
    case 'purple':
      return 'text-grape-800'
    case 'default':
    default:
      return 'text-dark-ui-200'
  }
})

const darkBrowserSlopeColorClass = computed(() => {
  switch (props.color) {
    case 'red':
      return 'dark:text-scarlet-800'
    case 'orange':
      return 'dark:text-tangerine-800'
    case 'green':
      return 'dark:text-park-800'
    case 'blue':
      return 'dark:text-oceanic-800'
    case 'purple':
      return 'dark:text-grape-800'
    case 'default':
    default:
      return 'dark:text-dark-ui-200'
  }
})

return { __sfc: true,props, isBrowserDecidingDarkMode, isForcedLight, isForcedDark, wavySvgSize, lightMainBgColorClass, darkMainBgColorClass, darkBrowserMainBgColorClass, lightSlopeColorClass, darkSlopeColorClass, darkBrowserSlopeColorClass, dir }
}

})